/**
 * MiseOne EmptyState (Prompt 16B).
 *
 * Always: icon + short title + 1-2 sentence description + primary action.
 * Use this instead of plain "No data" placeholders.
 */
import Button from "./Button";

export default function EmptyState({
    icon: Icon, title, description, action, testId,
    secondary,
}) {
    return (
        <div
            data-testid={testId || "empty-state"}
            className="kop-card p-12 text-center flex flex-col items-center"
        >
            {Icon && (
                <div className="h-14 w-14 rounded-full bg-neutral-100 grid place-items-center mb-5">
                    <Icon className="h-6 w-6 text-neutral-400" strokeWidth={1.5} />
                </div>
            )}
            <h3 className="font-display text-xl font-bold tracking-tight">{title}</h3>
            {description && (
                <p className="mt-2 text-sm text-neutral-500 max-w-md mx-auto leading-relaxed">
                    {description}
                </p>
            )}
            {action && (
                <div className="mt-6 flex flex-wrap gap-2 justify-center">
                    {action}
                    {secondary}
                </div>
            )}
        </div>
    );
}

export { Button };
